import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CoreModule } from "../core/core.module";
import { MaskDirective } from "./mask.directive";
import { CustomColumnTemplateDirective } from "./custom-column-template.directive";
import { FilterItemDirective } from "./filter-item.directive";

@NgModule({
  declarations: [ 
    FilterItemDirective,
    MaskDirective, 
    CustomColumnTemplateDirective,
  ],
  exports: [
    FilterItemDirective,
    MaskDirective, 
    CustomColumnTemplateDirective
  ],
  imports: [CoreModule, CommonModule],
})
export class DirectiveModule { }
